import { DEFAULT_COLORS } from 'constants/colors';
import styled from 'styled-components';

/**
 * A single Breadcrumb Item component.
 *
 * @constructor
 */
const BreadcrumbsItem = styled.li`
    max-width: 100%;
    display: inline;
    span {
        &[type='breadCrumbLink'] {
            &:hover {
                color: ${DEFAULT_COLORS.BLACK} !important;
            }
        }
        &[type='separator'] {
            line-height: 0;
        }
    }
`;

export default BreadcrumbsItem;
